module.exports = __webpack_public_path__ + "static/img/far3.3c89af38.png";